import PropTypes from 'prop-types';

export default PropTypes.shape({
    sectionTitle: PropTypes.string.isRequired,
    text: PropTypes.node.isRequired,
    image: PropTypes.shape({
        srcDesktop: PropTypes.string,
        srcMobile: PropTypes.string,
        displayImage: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.bool,
        ]),
        altText: PropTypes.string,
    }),
    showOnAllPages: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.bool,
    ]),
    links: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
    })),
    selectSports: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })),
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
    ]),
});
